import styled from "styled-components";

import colors from "../../../assets/css/colors";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 60px;

    @media (max-width: 500px){
        display: block;
    }
`;

export const FieldTitle = styled.h2`
    font: normal normal normal 14px Circular Std Book;
    color: #454546;
    margin-bottom: 24px;
`;

export const DropzoneContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 25px;
`;

export const TranparentButton = styled.button`
    font: normal normal normal 11px/15px Circular Std Book;
    color: ${colors.primary};
    background-color: #FFF;
    border: 0px;
    outline: 0px;

    &:focus{
        outline: 0;
    }
`;

export const ButtonContainer = styled.div`
    width: 30%;

    @media (max-width: 500px){
        width: 100%;
    }
`

export const TitleField = styled.h2`
    font: normal normal normal 16px Circular Std Book;
    margin-bottom: 24px;
    color: #454546;
`;

export const RowForInput = styled.div`
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin-bottom: 43px;
    align-items: center;

    @media (max-width: 500px){
        display: block;
        margin-bottom: 0px;
    }
`;

export const EstablishmentSelected = styled.span`
    font: normal normal normal 16px Circular Std Book;
    margin-bottom: 24px;
    color: ${colors.primary};
`

export const ContainerDropzone = styled.div`
    width: 30%;
    margin-right: 50px;
    
    @media (min-width: 501px) and (max-width: 1000px) {
        width: 45%;
    }
    @media (max-width: 500px) {
        width: 100%;
        margin-bottom: 35px;
    }
`

export const Title = styled.h2`
    font: normal normal 600 14px Muli;
    letter-spacing: 0.7px;
    color: #454546;
    margin-bottom: 4px;
    line-height: 1;
`;

export const Info = styled.p`
    margin-bottom: 0px;
    font: normal normal 600 14px Muli;
    letter-spacing: 0.7px;
    color: #B8B4CC;
`;